var map = {
	"./0001-donacion-J-J-Loleo-Rotonda-plaza.jpg": 9308,
	"./0003-donacion-J-J-Loleo-plaza-rotonda.jpg": 7607,
	"./0006-donacion-J-J-Loleo-iglesia-plaza.jpg": 1223,
	"./0011-donacion-J-J-Loleo-municipalidad-sociedad.jpg": 6477,
	"./0012-donacion-J-J-Loleo-Fitte-sociedad.jpg": 478,
	"./0014-Inauguracion-estatua-de-H-Vieytes-presente-el-gobernador-Luis-Cantilo-1924.jpg": 3604,
	"./0015-donacion-J-J-Loleo-plaza-iglesia.jpg": 6549,
	"./0016-donacion-J-J-Loleo-carrera-autos-Vagues.jpg": 137,
	"./0017-donacion-J-J-Loleo-carrera-autos-Vagues.jpg": 665,
	"./01 El Puente Viejo.jpg": 7367,
	"./06 botesnautico.jpg": 1199,
	"./1.jpg": 5676,
	"./11.jpg": 6375,
	"./111.jpg": 1908,
	"./113.jpg": 5142,
	"./12.jpg": 9902,
	"./13.jpg": 9623,
	"./14.jpg": 2946,
	"./15.jpg": 9317,
	"./16.jpg": 3404,
	"./17.jpg": 410,
	"./18.jpg": 7514,
	"./19.jpg": 6733,
	"./1921-dic-8-Medicos-Alberto-Sechi-Valerio-Quallart-Alejandro-LLamosas-Anastasio-Chaves.jpg": 385,
	"./1921-sept-25-Gobernador-Monteverde-intendente-F.-Speroni-2.jpg": 3973,
	"./1938--Pulperia-puente-Castex-N.jpg": 6570,
	"./2.jpg": 9592,
	"./20.jpg": 6451,
	"./21.jpg": 9987,
	"./22.jpg": 9877,
	"./23.jpg": 5219,
	"./24.jpg": 5558,
	"./25.jpg": 3460,
	"./26.jpg": 1695,
	"./27.jpg": 8611,
	"./28.jpg": 1920,
	"./29.jpg": 5732,
	"./3.jpg": 8019,
	"./30.jpg": 3855,
	"./31.jpg": 1028,
	"./32.jpg": 263,
	"./33.jpg": 2184,
	"./34.jpg": 7469,
	"./35.jpg": 5966,
	"./36.jpg": 9887,
	"./39.jpg": 6142,
	"./4.jpg": 5299,
	"./40.jpg": 9162,
	"./41.jpg": 8875,
	"./42.jpg": 6134,
	"./43.jpg": 5164,
	"./44.jpg": 5763,
	"./45.jpg": 9868,
	"./46.jpg": 4173,
	"./47.jpg": 7683,
	"./49.jpg": 6241,
	"./5.jpg": 2314,
	"./50.jpg": 236,
	"./51.jpg": 1641,
	"./52.jpg": 4328,
	"./54.jpg": 7777,
	"./6.jpg": 5000,
	"./7.jpg": 8104,
	"./76911_A-Plaza-Arellano.jpg": 3788,
	"./76913_A-Rotonda-Vieytes.jpg": 7390,
	"./76930_A-R+¡o-Areco-Puente-Viejo.jpg": 7144,
	"./76931_A-Puente-Viejo.jpg": 5695,
	"./8.jpg": 2418,
	"./9.jpg": 7617,
	"./Aerea-1.jpg": 3427,
	"./Alsina sacando empedrado 1.jpg": 6780,
	"./Alsina sacando empedrado 2.jpg": 1959,
	"./Alsina y Alem2.jpg": 6538,
	"./Alsina y Gral Paz.jpg": 145,
	"./Alsina y Gral Paz1.jpg": 8297,
	"./Alsina-y-Alem3.jpg": 8270,
	"./Alsina-y-Gral-Paz2.jpg": 1563,
	"./Alsina-y-San-Martin.jpg": 6753,
	"./Antigua-Municipalidad.jpg": 8547,
	"./Esquina Bco Nacion.jpg": 9861,
	"./Hogar-San-Jose.jpg": 400,
	"./IGLESIA-Y-COLEGIO-SAN-PATRICIO.jpg": 4688,
	"./La Favorita - Tokio.jpg": 1821,
	"./Museo-Ricardo-Guiraldes.jpg": 3571,
	"./Nacionalizaci+¦n del Colegio Juan Hipolito Vieytes-1956.jpg": 2813,
	"./OBRA-BS-AS-ROSARIO-ASFALTO-1936.jpg": 9718,
	"./PLAZA-ARELLANO009.jpg": 6216,
	"./Pag-115--.jpg": 1969,
	"./Pag-116--.jpg": 8708,
	"./Pag-17---a.jpg": 4023,
	"./Pag-204---c.jpg": 4004,
	"./Pag-43-.jpg": 3575,
	"./Pag-63--.jpg": 3987,
	"./Pag-64--.jpg": 4107,
	"./Pag-76--.jpg": 9231,
	"./Pag-77--.jpg": 2799,
	"./Pag-81--.jpg": 5531,
	"./Pag-87---b.jpg": 6305,
	"./Pag-93---a.jpg": 9186,
	"./Patio-La-Blanqueada.jpg": 6235,
	"./Plaza.jpg": 9056,
	"./Puente-Viejo.jpg": 8154,
	"./San-Patricio.jpg": 2293,
	"./TRABAJADORES-RURALES-25-6-1939.jpg": 1134,
	"./aerea.jpg": 1143,
	"./carnaval.jpg": 2279,
	"./carnicero de campo.jpg": 3036,
	"./cinevieytes.jpg": 1968,
	"./domingopazzaglia.jpg": 6413,
	"./rioarecoguallard.jpg": 7218,
	"./rioarecoguallard1.jpg": 851
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9947;